import script from "./demppythonSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./demppythonSetup.vue?vue&type=script&setup=true&lang=js"

import "./demppythonSetup.vue?vue&type=style&index=0&id=4b4e1a65&scoped=true&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b4e1a65"]])

export default __exports__